var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "process" }, [
    _vm.state !== ""
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/submit@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("申请售后")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === ""
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/submit_orange@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("申请售后")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 1
      ? _c("div", { staticClass: "spot" }, [
          _c("p", { staticClass: "fs12 font-color-FF7 mar-bot-10" }, [
            _vm._v("审核中")
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("../../../static/image/xzdiandian@2x.png"),
              alt: ""
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state !== 1 && _vm.state !== ""
      ? _c("div", { staticClass: "spot" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/line@2x.png"),
              alt: ""
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === ""
      ? _c("div", { staticClass: "spot" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/huidiandian@2x.png"),
              alt: ""
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 1 || _vm.state === ""
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/order_grey@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("订单处理")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 2 ||
    _vm.state === 3 ||
    _vm.state === 4 ||
    _vm.state === 5 ||
    _vm.state === 8 ||
    _vm.state === 9 ||
    _vm.state == 10
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/order@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("审核通过")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 6 || _vm.state === 7
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/order@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("审核不通过")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 10 || _vm.state === 7
      ? _c("div", { staticClass: "spot" }, [
          _vm.state === 10
            ? _c("p", { staticClass: "fs12 font-color-FF7 mar-bot-10" }, [
                _vm._v("录入物流")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state === 7
            ? _c("p", { staticClass: "fs12 font-color-FF7 mar-bot-10" }, [
                _vm._v("评审中")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("../../../static/image/xzdiandian@2x.png"),
              alt: ""
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 1 || _vm.state === 6 || _vm.state === ""
      ? _c("div", { staticClass: "spot" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/huidiandian@2x.png"),
              alt: ""
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 2 ||
    _vm.state === 3 ||
    _vm.state === 4 ||
    _vm.state === 5 ||
    _vm.state === 8 ||
    _vm.state === 9
      ? _c("div", { staticClass: "spot" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/line@2x.png"),
              alt: ""
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 3
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/transport_orange@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("退货中")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 1 ||
    _vm.state === 6 ||
    _vm.state === 10 ||
    _vm.state === 7 ||
    _vm.state === ""
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/transport_grey@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("退货中")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 2 ||
    _vm.state === 4 ||
    _vm.state === 5 ||
    _vm.state === 8 ||
    _vm.state === 9
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/transport@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("退货中")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 2
      ? _c("div", { staticClass: "spot" }, [
          _c("p", { staticClass: "fs12 font-color-FF7 mar-bot-10" }, [
            _vm._v("退款中")
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("../../../static/image/xzdiandian@2x.png"),
              alt: ""
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 4 || _vm.state === 5 || _vm.state === 8 || _vm.state === 9
      ? _c("div", { staticClass: "spot" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/line@2x.png"),
              alt: ""
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 1 ||
    _vm.state === 3 ||
    _vm.state === 6 ||
    _vm.state === 7 ||
    _vm.state === 10 ||
    _vm.state === ""
      ? _c("div", { staticClass: "spot" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/huidiandian@2x.png"),
              alt: ""
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 4
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/complete@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("退款成功")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 5
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/complete@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("退款失败")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 8
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/complete@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("退货完成，拒绝退款")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 9
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/complete@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("已关闭")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === 1 ||
    _vm.state === 2 ||
    _vm.state === 3 ||
    _vm.state === 6 ||
    _vm.state === 7 ||
    _vm.state === 10 ||
    _vm.state === ""
      ? _c("div", { staticClass: "box" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/complete_grey@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("完成")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7a75dda8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7a75dda8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/afterSaleState.vue
// module id = null
// module chunks = 